import React from "react";

const GridThree = () => {
    return(
        <div className="item-three">
            <img className="myimage" src="/images/mobile/image-stand-out.jpg" alt="pink pot" />
        </div>
    )
}

export default GridThree;